import * as React from "react";
export default function DirectAnswerBlock() {
  return <section id="direct-answer-block" className="w-full py-12 md:py-16 bg-card-foreground text-[var(--color-logo)]">
      <div className="container mx-auto px-4 md:px-6 max-w-4xl">
        <p className="text-lg md:text-xl font-default leading-relaxed font-medium text-center md:text-left">
          Arc flash label printing is the production of durable warning labels that display the arc flash hazard data for a specific piece of electrical equipment — incident energy, arc flash boundary, nominal voltage, and required PPE. Evermark Industrial Solutions produces these labels from a customer's arc flash study; the study itself must be performed by a qualified person.
        </p>
      </div>
    </section>;
}